import React from "react";

const icons = {
    wellness: (
        <>
            <path d="M12 20s-6.7-4.1-8.6-8.2A4.9 4.9 0 0 1 12 7.1a4.9 4.9 0 0 1 8.6 4.7C18.7 15.9 12 20 12 20Z" />
            <path d="M7.2 12h2l1.2-2.1 2.1 4.2 1.2-2.1h3.1" />
        </>
    ),
    healthTech: (
        <>
            <rect x="4.2" y="5.2" width="15.6" height="10.6" rx="2.2" />
            <path d="M9 19h6" />
            <path d="M12 15.8V19" />
            <path d="M9.2 10.5h5.6" />
            <path d="M12 7.8v5.4" />
            <path d="M16.9 8.4h.1" />
            <path d="M6.9 8.4H7" />
        </>
    ),
    marketing: (
        <>
            <path d="M4.2 13v-2a2 2 0 0 1 1.3-1.9l8.6-3.3a1 1 0 0 1 1.4.9v10.6a1 1 0 0 1-1.4.9l-8.6-3.3A2 2 0 0 1 4.2 13Z" />
            <path d="m8.2 14.8 1.5 3.2" />
            <path d="M16.5 9.1a4.4 4.4 0 0 1 0 5.8" />
            <path d="M18.7 7.3a7 7 0 0 1 0 9.4" />
        </>
    ),
    medical: (
        <>
            <rect x="4" y="6.2" width="16" height="11.6" rx="2.4" />
            <path d="M9 6.2V5a1.6 1.6 0 0 1 1.6-1.6h2.8A1.6 1.6 0 0 1 15 5v1.2" />
            <path d="M12 10v4" />
            <path d="M10 12h4" />
        </>
    ),
    production: (
        <>
            <rect x="3.8" y="7" width="11.8" height="10" rx="2.2" />
            <path d="m15.6 10 4-2.3a.8.8 0 0 1 1.2.7v7.2a.8.8 0 0 1-1.2.7l-4-2.3" />
            <path d="M7.2 7V5.2" />
            <path d="M12.2 7V5.2" />
        </>
    ),
    training: (
        <>
            <path d="M3.5 8.5 12 4l8.5 4.5L12 13 3.5 8.5Z" />
            <path d="M7 10.5v4.1c0 .9 2.2 2.4 5 2.4s5-1.5 5-2.4v-4.1" />
            <path d="M20.5 8.8v5.6" />
        </>
    ),
    education: (
        <>
            <path d="M3.5 8.5 12 4l8.5 4.5L12 13 3.5 8.5Z" />
            <path d="M7 10.5v4.1c0 .9 2.2 2.4 5 2.4s5-1.5 5-2.4v-4.1" />
            <path d="M20.5 8.8v5.6" />
            <path d="M19.4 16.1a1.1 1.1 0 1 0 2.2 0 1.1 1.1 0 0 0-2.2 0Z" />
        </>
    ),
    media: (
        <>
            <rect x="4" y="5.3" width="16" height="10.8" rx="2.2" />
            <path d="M10 19h4" />
            <path d="M12 16.1V19" />
            <path d="m10.2 8.7 4.4 2.1-4.4 2.1V8.7Z" />
        </>
    ),
    technology: (
        <>
            <rect x="8.2" y="8.2" width="7.6" height="7.6" rx="1.4" />
            <path d="M10.4 4.6v2" />
            <path d="M13.6 4.6v2" />
            <path d="M10.4 17.4v2" />
            <path d="M13.6 17.4v2" />
            <path d="M17.4 10.4h2" />
            <path d="M17.4 13.6h2" />
            <path d="M4.6 10.4h2" />
            <path d="M4.6 13.6h2" />
            <path d="M12 10.2v3.6" />
            <path d="M10.2 12h3.6" />
        </>
    ),
};

export default function GeneralLineIcon({ name, color = "currentColor", className = "" }) {
    const icon = icons[name];

    if (!icon) {
        return null;
    }

    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke={color}
            strokeWidth="1.9"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
        >
            {icon}
        </svg>
    );
}
